import { render, staticRenderFns } from "./PaginationControls.vue?vue&type=template&id=d50c2992&scoped=true"
import script from "./PaginationControls.vue?vue&type=script&lang=ts"
export * from "./PaginationControls.vue?vue&type=script&lang=ts"
import style0 from "./PaginationControls.vue?vue&type=style&index=0&id=d50c2992&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50c2992",
  null
  
)

export default component.exports